import React from "react";
import PropTypes from "prop-types";
import { useLive } from "../LiveProvider";
import { differenceInDays } from "date-fns";
import { ListingCard } from "@wrstudios/components";
import { Results, Grid, Cell } from "./styled/my-recent-sales-listings";
import { formatCurrency } from "@wrstudios/utils";

function MyRecentSalesListings({ setPreviewListingId, setHoverListingId }) {
  const { myRecentSales } = useLive();

  return (
    <Results>
      <Grid>
        {myRecentSales.map((listing) => (
          <Cell key={listing.recordId}>
            <ListingCard
              listingId={listing.recordId}
              handleMouseEnter={() => setHoverListingId(listing.recordId)}
              handleMouseLeave={() => setHoverListingId(null)}
              photos={listing.photos}
              address={listing.address}
              priceFormatted={
                listing.price ? `${formatCurrency(listing.price)}` : ""
              }
              city={listing.city}
              state={listing.state}
              zip={listing.zip}
              statusLabel={listing.status}
              statusValue={listing.mappedStatus}
              bedsFormatted={listing.beds ? `${listing.beds} Bds` : ""}
              bathsFormatted={listing.baths ? `${listing.baths} Ba` : ""}
              sqftFormatted={listing.sqft ? `${listing.sqft} sqft` : ""}
              built={listing.yearBuilt}
              updatedAtAgo={`${differenceInDays(
                new Date(),
                new Date(listing.soldDate)
              )} days ago`}
              handleClick={(e) => {
                e.stopPropagation();
                setPreviewListingId(listing.recordId);
              }}
            />
          </Cell>
        ))}
      </Grid>
    </Results>
  );
}

MyRecentSalesListings.defaultProps = {
  setPreviewListingId: () => {},
  setHoverListingId: () => {}
};

MyRecentSalesListings.propTypes = {
  setPreviewListingId: PropTypes.func,
  setHoverListingId: PropTypes.func
};

export default MyRecentSalesListings;
